import {
  USERS_TAB,
  ROLES_TAB,
  PRODUCTS_TAB,
  GENERATE_OTP_TAB,
  HEALTH_STATUS_TAB,
  RETAILER_REPORTS_TAB,
  CONFIGURATION_TAB,
} from "./tabUtilsConstants";
import Users from "../../apps/users/UsersReports";
import Roles from "../../apps/roles";
import Products from "../../apps/products";
import { initial_state_users } from "../../apps/users/constant";
import { initial_state_roles } from "../../apps/roles/constants";
import { initial_state_products } from "../../apps/products/ProductsConstants";
import GenerateOTP from "../../apps/generateOtp";
import { initial_state_generate_otp } from "../../apps/generateOtp/constants";
import HealthStatus from "../../apps/health";
import { initial_state_health_status } from "../../apps/health/constants";
import RetailerReports from "../../apps/retailer/RetailerReports";
import { initial_state_retailer_report } from "../../apps/retailer/RetailerReportsConstants";
import ConfigHome from "../../apps/configuration/ConfigHome";
import { initital_state_configuration } from "../../apps/configuration/configurationConstants";

export const getComponent = (type) => {
  switch (type) {
    case USERS_TAB:
      return Users;
    case ROLES_TAB:
      return Roles;
    case PRODUCTS_TAB:
      return Products;
    case GENERATE_OTP_TAB:
      return GenerateOTP;
    case HEALTH_STATUS_TAB:
      return HealthStatus;
    case RETAILER_REPORTS_TAB:
      return RetailerReports;
    case CONFIGURATION_TAB:
      return ConfigHome;
    default:
      return null;
  }
};

export const configureInitialState = (type, props) => {
  let __return = {};

  switch (type) {
    case USERS_TAB:
      __return = initial_state_users;
      break;
    case ROLES_TAB:
      __return = initial_state_roles;
      break;
    case PRODUCTS_TAB:
      __return = initial_state_products;
      break;
    case GENERATE_OTP_TAB:
      __return = initial_state_generate_otp;
      break;
    case HEALTH_STATUS_TAB:
      __return = initial_state_health_status;
      break;
    case RETAILER_REPORTS_TAB:
      __return = initial_state_retailer_report;
      break;
    case CONFIGURATION_TAB:
      __return = initital_state_configuration;
      break;
    default:
      __return = {};
  }

  if (props) {
    __return = { ...__return, props };
  }
  return __return;
};
